import './App.css';
import Home from './Components/Home/Home/Home';
import AnimatedCursor from "react-animated-cursor"
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import NotFound from './Components/NotFound/NotFound';


function App() {
  return (
    <Router>
      <Switch>

        <Route exact path='/'>
          <AnimatedCursor />
          <Home />
        </Route>

        <Route path='/home'>
          <AnimatedCursor />
          <Home />
        </Route>

        <Route path='/about'>
          <AnimatedCursor />
          <Home />
        </Route>

        <Route path='/projects'>
          <AnimatedCursor />
          <Home />
        </Route>

        <Route path='/expertise'>
          <AnimatedCursor />
          <Home />
        </Route>

        <Route path='/blogs'>
          <AnimatedCursor />
          <Home />
        </Route>

        <Route path='/contact'>
          <AnimatedCursor />
          <Home />
        </Route>

        <Route path='*'>
          <AnimatedCursor />
        <NotFound />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
